module.exports = __webpack_public_path__ + "static/media/bolso (21).2654df11.jpg";